export class User {
    
    constructor(
        public uid: string,
        public email: string,
        public phone: string,
        public firstname?: string,
        public lastname?: string,
        public status?: string,
        public role?:string,
        public address?
    ) {}

}